import React, { Component } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { customAlphabet } from "nanoid";
import { withRouter } from "react-router-dom";

//validators
import validator from "validator";
import validate from "is-my-date-valid";

// Assets
import Logo from "../imgs/logo.jpg";
import StopImage from "../imgs/stop.jpg";
import ToolTipIcon from "../imgs/tooltip.svg";

import baseurl from "./baseurl";

// Styles
import "../styles/Form1.css";
class Form1 extends Component {
  nanoid = customAlphabet("1234567890", 8);

  state = {
    pid: this.nanoid(),
    date: "",
    nonecheck: "",
    physician: "Yamini Maddala, M.D.",
    patient: "New Patient",
    referringPhysician: "",
    patientName: "",
    dob: "",
    gender: "",
    emailAddress: "",
    cellNumber: "",
    homeNumber: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    nameofHealthPlan: "",
    insuredDOB: "",
    insuranceID: "",
    groupPlanID: "",
    pharmacy: "",
    pharmacyPhoneLocation: "",
    colonoscopyinthepast: "",
    when: "",
    where: "",
    colonoscopyResults: "",
    colonoscopyOtherResult: "",
    weight: 0,
    height: "",
    feet: 0,
    inches: 0,
    bmi: 0,
    medications: [{ name: "" }, { name: "" }],
    allergies: "",
    heartAttack: "",
    myocardial_text: "",
    cardiacStent: "",
    valvularHeart: "",
    pacemaker: "",
    heartAttack_aortic_stenosis: false,
    heartAttack_heart_failure: false,
    heartAttack_unstable_angina: false,
    heartAttack_stents: false,
    stenosisStents: "",
    bloodthinners: "",
    cardiac_stent_text: "",
    breathingproblems: "",
    oxygen: "",
    kidneydisease: "",
    couldbepregnant: "",
    bloodpressure: "",
    controlledwithmedication: "",
    historyofseizures: "",
    diabetic: "",
    diabeticyes: "",
    diabeticOther_text: "",
    anxietymedication: "",
    circulatorydisorders: "",
    circulatoryothername: "",
    problemwithanesthesia: "",
    transplantother: "",
    transplantotheryes: "",
    errorMessage: "",
    bowelMovement: "yes",
    bowelMovement_options: "",
    bowelMovement_other_text: "",
    confirmationAlert: false,
    checkvalidation: "",
    loading: false,
  };

  redirect = () => {
    this.props.history.push("/thank-you");
  };

  bmiCalculator = () => {
    if (!this.state.weight || !this.state.feet) {
      this.setState({
        errorMessage: "Please enter valid Weight and Height to calculate BMI",
      });
    } else {
      const lbs = parseInt(this.state.weight);
      const inc = parseInt(this.state.feet * 12) + parseInt(this.state.inches);
      const bmi = ((lbs / (inc * inc)) * 703).toFixed(2);
      this.setState({
        height: `${this.state.feet} feet`.toString(),
      });
      this.setState({
        bmi: bmi,
      });
    }
  };

  onChange = (e) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({
      [e.target.name]: value,
    });
  };

  CheckItem = (e) => {
    let value = e.target.checked;
    this.setState({ [e.target.name]: value });
  };

  addMedications = (e) => {
    let medications = this.state.medications;
    this.setState({
      [e.target.name]: e.target.value,
    });
    medications.push({ [e.target.name]: e.target.value });
  };

  handleNameChange = (evt) => {
    this.setState({ name: evt.target.value });
  };

  handleMedicationNameChange = (idx) => (evt) => {
    const newMedications = this.state.medications.map((medication, sidx) => {
      if (idx !== sidx) return medication;
      return { ...medication, name: evt.target.value };
    });

    this.setState({ medications: newMedications });
  };

  handleAddMedication = () => {
    this.setState({
      medications: this.state.medications.concat([{ name: "" }]),
    });
  };

  handleRemoveMedication = (idx) => () => {
    this.setState({
      medications: this.state.medications.filter((s, sidx) => idx !== sidx),
    });
  };

  handleAlert = () => {
    this.setState({
      errorMessage: "",
    });
  };

  handleDownload = async () => {
    let name = this.state.patientName.replace(/ .*/, "");
    let pid = this.state.pid;
    let patientId = name + pid;
    axios
      .get(`${baseurl}/form1/fetch-pdf/${patientId}`, { responseType: "blob" })
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        saveAs(pdfBlob, patientId + ".pdf");
      });
  };

  handleValidation = () => {
    const mandateFields = [
      this.state.patientName,
      this.state.gender,
      this.state.dob,
      this.state.cellNumber,
      this.state.emailAddress,
      this.state.date,
      this.state.physician,
      this.state.referringPhysician,
      this.state.address,
      this.state.city,
      this.state.state,
      this.state.zip,
      this.state.colonoscopyinthepast,
      this.state.weight,
      this.state.feet,
      this.state.inches,
      this.state.bmi,
      this.state.medications,
      this.state.heartAttack,
      this.state.cardiacStent,
      this.state.valvularHeart,
      this.state.pacemaker,
      this.state.bloodpressure,
      this.state.bloodthinners,
      this.state.breathingproblems,
      this.state.oxygen,
      this.state.kidneydisease,
      this.state.couldbepregnant,
      this.state.diabetic,
      this.state.anxietymedication,
      this.state.circulatorydisorders,
      this.state.transplantother,
      this.state.bowelMovement_options,
      this.state.problemwithanesthesia,
    ];

    if (
      !mandateFields.includes("") &&
      !mandateFields.includes(null) &&
      !mandateFields.includes(undefined)
    ) {
      if (this.state.colonoscopyinthepast === "yes") {
        if (this.state.when === "" || this.state.where === "") {
          this.setState({
            errorMessage: "All fields marked with * are mandatory",
          });
          return this.setState({ checkvalidation: false });
        } else {
          this.setState({ checkvalidation: true });
        }
      }
      if (this.state.bloodpressure === "yes") {
        if (
          this.state.controlledwithmedication === "" ||
          this.state.controlledwithmedication === null ||
          this.state.controlledwithmedication === undefined
        ) {
          this.setState({
            errorMessage: "All fields marked with * are mandatory",
          });
          return this.setState({ checkvalidation: false });
        } else {
          this.setState({ checkvalidation: true });
        }
      }
      if (this.state.diabetic === "yes") {
        if (
          this.state.diabeticyes === "" ||
          this.state.diabeticyes === null ||
          this.state.diabeticyes === undefined
        ) {
          this.setState({
            errorMessage: "All fields marked with * are mandatory",
          });
          return this.setState({ checkvalidation: false });
        } else {
          this.setState({ checkvalidation: true });
        }
      }

      if (this.state.circulatorydisorders === "yes") {
        if (
          this.state.circulatoryothername === "" ||
          this.state.circulatoryothername === null ||
          this.state.circulatoryothername === undefined
        ) {
          this.setState({
            errorMessage: "All fields marked with * are mandatory",
          });
          return this.setState({ checkvalidation: false });
        } else {
          this.setState({ checkvalidation: true });
        }
      }

      if (this.state.problemwithanesthesia === "yes") {
        if (
          this.state.problemwithanesthesiayes === "" ||
          this.state.problemwithanesthesiayes === null ||
          this.state.problemwithanesthesiayes === undefined
        ) {
          this.setState({
            errorMessage: "All fields marked with * are mandatory",
          });
          return this.setState({ checkvalidation: false });
        } else {
          this.setState({ checkvalidation: true });
        }
      }
      if (this.state.transplantother === "yes") {
        if (
          this.state.transplantotheryes === "" ||
          this.state.transplantotheryes === null ||
          this.state.transplantotheryes === undefined
        ) {
          this.setState({
            errorMessage: "All fields marked with * are mandatory",
          });
          return this.setState({ checkvalidation: false });
        }
      } else {
        this.setState({ checkvalidation: true });
      }
    } else {
      this.setState({
        errorMessage: "All fields marked with * are mandatory",
      });
      this.setState({ checkvalidation: false });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.handleValidation();
    this.setState({}, () => {
      if (this.state.checkvalidation) {
        // show loader
        this.setState({
          loading: true,
        });
        axios
          .post(`${baseurl}/form1/create-pdf`, this.state)
          .then((res) => {
            if (res.status === 200) {
              // hide loader
              this.setState({
                loading: false,
              });

              // empty the state
              this.setState({});

              // redirect to destination
              this.redirect();
            } else
              this.setState({
                errorMessage: "Something went wrong, please try again later",
              });
          })
          .catch((error) => {
            this.setState({
              errorMessage: error,
            });
          });
      }
    });
  };

  render() {
    const valid = validate({ format: "MM/DD/YYYY" });

    const {
      physician,
      patient,
      colonoscopyinthepast,
      heartAttack,
      myocardial_text,
      cardiac_stent_text,
      cardiacStent,
      valvularHeart,
      bloodthinners,
      breathingproblems,
      oxygen,
      kidneydisease,
      couldbepregnant,
      bloodpressure,
      controlledwithmedication,
      historyofseizures,
      diabetic,
      diabeticyes,
      anxietymedication,

      pacemaker,
      circulatorydisorders,
      problemwithanesthesia,
      transplantother,
      bowelMovement,
      bowelMovement_options,
      bowelMovement_other_text,
    } = this.state;

    return (
      <div className="relative">
        <div className="userdetails_wrapper_main">
          <div className="userdetails_wrapper">
            <div className="header_sec">
              <div className="header_logo_left">
                <a href="/">
                  <img src={Logo} alt="DHAT" />
                </a>
              </div>
              <div className="header_right">
                <p>Yamini Maddala, M.D.,</p>
                <p>Deepti Dhavaleshwar, M.D.,</p>
                <p>
                  Phone: <span className="pno">469.697.5100</span>
                </p>
              </div>
            </div>
            <div className="userDetails_heading">
              <h1>Colonoscopy Questionnaire</h1>
            </div>

            {/* Errors are shown here */}
            {this.state.errorMessage && (
              <div className="alert">
                <span className="closebtn" onClick={this.handleAlert}>
                  &times;
                </span>
                {this.state.errorMessage}
              </div>
            )}

            {/* Form - Start */}
            <form>
              <div className="initial_details">
                <div className="details_date">
                  <div className="date_1">
                    <p>
                      Date<span className="mandate">*</span>:
                    </p>
                    <input
                      className="mr-2"
                      name="date"
                      id="currentdate"
                      type="tel"
                      maxLength="10"
                      onChange={(e) => this.setState({ date: e.target.value })}
                      placeholder="mm/dd/yyyy"
                    />
                    {valid(this.state.date) ? null : this.state.date ===
                      "" ? null : (
                      <span className="error">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-20 w-20 mr-2"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Please enter valid date (mm/dd/yyyy)
                      </span>
                    )}
                  </div>
                  <div className="phy_1">
                    <p>
                      Physician<span className="mandate">*</span>:
                    </p>
                    <div className="doctor_name_one">
                      <input
                        type="radio"
                        name="physician"
                        value="Yamini Maddala, M.D."
                        checked={physician === "Yamini Maddala, M.D."}
                        onChange={this.onChange}
                      />
                      <p>Yamini Maddala, M.D.</p>
                    </div>
                    <div className="doctor_name_two">
                      <input
                        type="radio"
                        name="physician"
                        value="Deepti Dhavaleshwar, M.D."
                        checked={physician === "Deepti Dhavaleshwar, M.D."}
                        onChange={this.onChange}
                      />
                      <p>Deepti Dhavaleshwar, M.D.</p>
                    </div>
                  </div>
                </div>
                <div className="new_patient_row">
                  <div className="new_patient_left">
                    <input
                      type="radio"
                      name="patient"
                      value="New Patient"
                      checked={patient === "New Patient"}
                      onChange={this.onChange}
                    />
                    <p>New Patient</p>
                    <input
                      type="radio"
                      name="patient"
                      value="Follow Up"
                      checked={patient === "Follow Up"}
                      onChange={this.onChange}
                    />
                    <p>Follow Up</p>
                  </div>
                  <div className="new_patient_right">
                    <p>
                      Referring Physician<span className="mandate">*</span>:
                    </p>
                    <input
                      type="text"
                      name="referringPhysician"
                      onChange={this.onChange}
                    />
                  </div>
                </div>
              </div>
              <div className="secondary_details">
                <div className="secondary_details_inner">
                  <div className="patient_details">
                    <p>
                      Patient Name<span className="mandate">*</span>:{" "}
                    </p>
                    <input
                      type="text"
                      name="patientName"
                      maxLength="59"
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="patient_dob">
                    <div className="flex">
                      <p>
                        DOB<span className="mandate">*</span>:{" "}
                      </p>
                      <input
                        name="dob"
                        id="dateofbirth"
                        type="tel"
                        maxLength="10"
                        onChange={(e) => this.setState({ dob: e.target.value })}
                        placeholder="mm/dd/yyyy"
                      ></input>
                    </div>
                    {valid(this.state.dob) ? null : this.state.dob ===
                      "" ? null : (
                      <span className="error">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-20 w-20 mr-2"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Please enter valid date (mm/dd/yyyy)
                      </span>
                    )}
                  </div>
                </div>
                <div className="patient_gender">
                  <div className="patient_gender_inner_one">
                    <p className="label">
                      Sex<span className="mandate">*</span>:
                    </p>
                    <input
                      type="radio"
                      name="gender"
                      value="Male"
                      onChange={this.onChange}
                    />
                    <p>Male</p>
                  </div>
                  <div className="patient_gender_inner_two">
                    <input
                      type="radio"
                      name="gender"
                      value="Female"
                      onChange={this.onChange}
                    />
                    <p>Female</p>
                  </div>
                  <div className="patient_gender_inner_three">
                    <input
                      type="radio"
                      name="gender"
                      value="Transgender"
                      onChange={this.onChange}
                    />
                    <p>Transgender</p>
                  </div>
                </div>
                <div className="patient_contact_info">
                  <div className="email">
                    <p className="label">
                      Email Address<span className="mandate">*</span>:{" "}
                    </p>
                    <input
                      type="email"
                      maxLength="59"
                      name="emailAddress"
                      onChange={this.onChange}
                    />
                    {validator.isEmail(this.state.emailAddress) ? null : this
                        .state.emailAddress === "" ? null : (
                      <span className="error w-100">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-20 w-20 mr-2"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Please enter valid email
                      </span>
                    )}
                  </div>
                  <div className="cell">
                    <p className="label">
                      Cell Number<span className="mandate">*</span>:
                    </p>
                    <input
                      type="text"
                      id="yourphone"
                      name="cellNumber"
                      onChange={this.onChange}
                    />
                    <div className="w-100">
                      {this.state.cellNumber.length === 12 ? null : this.state
                          .cellNumber === "" ? null : (
                        <span className="error">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-20 w-20 mr-2"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                          Please enter valid phone number
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="home">
                    <p className="label">Home Number:</p>
                    <input
                      type="text"
                      id="yourphone1"
                      name="homeNumber"
                      onChange={this.onChange}
                    />
                    <div className="w-100">
                      {this.state.homeNumber.length === 12 ? null : this.state
                          .homeNumber === "" ? null : (
                        <span className="error">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-20 w-20 mr-2"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                          Please enter valid phone number
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="patient_address_first">
                  <p className="label">
                    Address<span className="mandate">*</span>:
                  </p>
                  <input type="text" name="address" onChange={this.onChange} />
                </div>
                <div className="patient_address_second">
                  <div className="city">
                    <p className="label">
                      City<span className="mandate">*</span>:
                    </p>
                    <input
                      type="text"
                      name="city"
                      maxLength="24"
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="state">
                    <p className="label">
                      State<span className="mandate">*</span>:
                    </p>
                    <input
                      type="text"
                      name="state"
                      maxLength="15"
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="zip">
                    <p className="label">
                      Zip<span className="mandate">*</span>:
                    </p>
                    <input
                      type="text"
                      maxLength="5"
                      name="zip"
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                <div className="name_health">
                  <div className="namehealth_left">
                    <p className="label">Name of Health Plan:</p>
                    <input
                      type="text"
                      name="nameofHealthPlan"
                      onChange={this.onChange}
                      maxLength="59"
                    />
                  </div>
                  <div className="namehealth_right err">
                    <p className="label">Insured DOB:</p>
                    <input
                      name="insuredDOB"
                      id="insureddate"
                      type="tel"
                      maxLength="10"
                      onChange={(e) =>
                        this.setState({ insuredDOB: e.target.value })
                      }
                      placeholder="mm/dd/yyyy"
                    ></input>
                    {valid(this.state.insuredDOB) ? null : this.state
                        .insuredDOB === "" ? null : (
                      <span className="error">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-20 w-20 mr-2"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Please enter valid date (mm/dd/yyyy)
                      </span>
                    )}
                  </div>
                </div>
                <div className="insurance">
                  <div className="insurance_left">
                    <p className="label">Insurance ID:</p>
                    <input
                      type="text"
                      name="insuranceID"
                      onChange={this.onChange}
                      maxLength="59"
                    />
                  </div>
                  <div className="insurance_right">
                    <p className="label">Group Plan ID:</p>
                    <input
                      type="text"
                      name="groupPlanID"
                      onChange={this.onChange}
                      maxLength="59"
                    />
                  </div>
                </div>
                <div className="pharmacy">
                  <div className="pharmacy_left">
                    <p className="label">Pharmacy:</p>
                    <input
                      type="text"
                      name="pharmacy"
                      onChange={this.onChange}
                      maxLength="59"
                    />
                  </div>
                  <div className="pharmacy_right">
                    <p className="label">Pharmacy Phone/Location:</p>
                    <input
                      type="text"
                      name="pharmacyPhoneLocation"
                      onChange={this.onChange}
                      maxLength="59"
                    />
                  </div>
                </div>
              </div>
              <div className="colonoscopy_wrapper">
                <div className="Colonoscopy">
                  <div className="question_left">
                    <div className="question_left_content">
                      <p>
                        Have you had a Colonoscopy in the past?
                        <span className="mandate">*</span>:
                      </p>
                      <input
                        type="radio"
                        name="colonoscopyinthepast"
                        value="yes"
                        checked={colonoscopyinthepast === "yes"}
                        onChange={this.onChange}
                      />
                      <p>Yes</p>
                      <input
                        type="radio"
                        name="colonoscopyinthepast"
                        value="no"
                        checked={colonoscopyinthepast === "no"}
                        onChange={this.onChange}
                      />
                      <p>No</p>
                    </div>
                  </div>
                  <div className="question_right">
                    <div className="when_section flex">
                      <p>
                        When
                        {colonoscopyinthepast === "yes" ? (
                          <span className="mandate">*</span>
                        ) : null}
                        :{" "}
                      </p>
                      <input
                        name="when"
                        id="whendata"
                        type="text"
                        maxLength="10"
                        onChange={(e) =>
                          this.setState({ when: e.target.value })
                        }
                        placeholder="mm/dd/yyyy"
                      ></input>
                      {valid(this.state.when) ? null : this.state.when ===
                        "" ? null : (
                        <span className="error w-100">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-20 w-20 mr-2"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                          Please enter valid date (mm/dd/yyyy)
                        </span>
                      )}
                    </div>
                    <div className="where_section flex">
                      <p>
                        Where
                        {colonoscopyinthepast === "yes" ? (
                          <span className="mandate">*</span>
                        ) : null}
                        :{" "}
                      </p>
                      <input
                        type="text"
                        name="where"
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="result_section">
                  <div className="result1">
                    <p>
                      Results
                      {colonoscopyinthepast === "yes" ? (
                        <span className="mandate">*</span>
                      ) : null}
                      :{" "}
                    </p>
                    <input
                      type="checkbox"
                      value="colonoscopyResults_normal"
                      name="colonoscopyResults_normal"
                      onChange={this.onChange}
                    />
                    <p>Normal</p>
                  </div>
                  <div className="polly">
                    <input
                      type="checkbox"
                      value="colonoscopyResults_Polyps"
                      name="colonoscopyResults_Polyps"
                      onChange={this.onChange}
                    />
                    <p>Polyps</p>
                  </div>
                  <div className="cancer">
                    <input
                      type="checkbox"
                      value="colonoscopyResults_Cancer"
                      name="colonoscopyResults_Cancer"
                      onChange={this.onChange}
                    />
                    <p>Cancer</p>
                  </div>
                  <div className="other">
                    <input
                      type="checkbox"
                      value="colonoscopyResults_other"
                      name="colonoscopyResults_other"
                      onChange={this.onChange}
                    />
                    <p>Other:</p>
                    <input
                      type="text"
                      name="colonoscopyOtherResult"
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                {/* ) : (
                  <React.Fragment></React.Fragment>
                )} */}
                <div className="weight">
                  <div className="weight_1">
                    <p>
                      Weight<span className="mandate">*</span>:{" "}
                    </p>
                    <input
                      type="text"
                      maxLength="3"
                      name="weight"
                      onChange={this.onChange}
                    />
                    <span>lbs</span>
                  </div>
                  <div className="weight_2">
                    <p>
                      Height<span className="mandate">*</span>:
                    </p>
                    <input
                      type="text"
                      maxLength="1"
                      name="feet"
                      onChange={this.onChange}
                    />
                    <span>Feet</span>
                    <input
                      type="number"
                      id="feets"
                      name="inches"
                      onChange={this.onChange}
                    />
                    <span>Inches</span>
                  </div>
                  <div className="weight_3">
                    <p>BMI:</p>
                    <div className="tooltip">
                      <span className="icon">
                        <img
                          src={ToolTipIcon}
                          width="20px"
                          height="20px"
                          alt="BMI - We convert the input values (lbs, feet) into the metric system (kgs, meter square)"
                        />
                      </span>
                      <span className="text">
                        We convert the input values (lbs, feet) into the metric
                        system (kgs, meter square)
                      </span>
                    </div>
                    <input
                      type="text"
                      name="bmi"
                      onChange={this.onChange}
                      value={this.state.bmi ? this.state.bmi.toString() : "0"}
                      disabled
                    />
                    <input
                      type="button"
                      className="btn_bmi"
                      value="Calculate BMI"
                      onClick={this.bmiCalculator}
                    />
                  </div>
                  <div className="weight_4">
                    <p>&gt; 50 make office visit</p>
                  </div>
                </div>
                <div className="medication_sec">
                  <p>
                    <span>
                      <span className="medi_text1">
                        Medications<span className="mandate">*</span>:
                      </span>{" "}
                      Name, Dose, How Often
                    </span>{" "}
                    <input
                      type="checkbox"
                      id="nonecheck"
                      value="none"
                      name="nonecheck"
                      onChange={(e) => this.CheckItem(e)}
                      // checked={this.state.medications.length > 0 ? false : true}
                    />
                    None
                  </p>
                </div>
                {this.state.nonecheck ? (
                  <React.Fragment></React.Fragment>
                ) : (
                  <>
                    <div className="medications_wrapper">
                      {this.state.medications.map((medication, idx) => (
                        <div className="medications_left" key={idx}>
                          <p>{idx + 1}.</p>
                          <input
                            type="text"
                            placeholder={`Medication ${idx + 1}`}
                            value={medication.name}
                            onChange={this.handleMedicationNameChange(idx)}
                          />
                          <button
                            type="button"
                            onClick={this.handleRemoveMedication(idx)}
                            className="remove_medication"
                          >
                            &#10006;
                          </button>
                        </div>
                      ))}
                    </div>
                    <button
                      type="button"
                      onClick={this.handleAddMedication}
                      className="add_medication"
                    >
                      Add medication
                    </button>
                  </>
                )}
                <div className="Allergies">
                  <p>Allergies:</p>
                  <input
                    type="text"
                    name="allergies"
                    onChange={this.onChange}
                  />
                </div>
                {/* ==================== yes no  new html start ======================= */}
                <div className="yes_wrapper">
                  <div className="yes_n_content">
                    <p>Yes</p>
                    <p style={{ marginLeft: "15px" }}>No</p>
                    <span className="mandate">*</span>:
                  </div>
                  <div className="yes_nonew_sec">
                    <div className="yes_no_check">
                      <input
                        type="radio"
                        value="yes"
                        name="heartAttack"
                        checked={heartAttack === "yes"}
                        onChange={this.onChange}
                      />
                      <input
                        type="radio"
                        value="no"
                        name="heartAttack"
                        checked={heartAttack === "no"}
                        onChange={this.onChange}
                        style={{ marginLeft: "20px" }}
                      />
                    </div>
                    <div className="yes_no_text">
                      <p>
                        Do you have a history of Myocardial Infarction? If yes,
                        how long ago ?
                        <React.Fragment>
                          <span className="d11">
                            <input
                              type="text"
                              name="myocardial_text"
                              onChange={this.onChange}
                            />
                          </span>
                        </React.Fragment>
                      </p>
                    </div>
                  </div>

                  <div className="yes_nonew_sec">
                    <div className="yes_no_check">
                      <input
                        type="radio"
                        value="yes"
                        name="cardiacStent"
                        checked={cardiacStent === "yes"}
                        onChange={this.onChange}
                      />
                      <input
                        type="radio"
                        value="no"
                        name="cardiacStent"
                        checked={cardiacStent === "no"}
                        onChange={this.onChange}
                        style={{ marginLeft: "20px" }}
                      />
                    </div>
                    <div className="yes_no_text">
                      <p>
                        Do you have Cardiac Stents ? If yes, how long ago were
                        they placed ?
                        <React.Fragment>
                          <span className="d11">
                            <input
                              type="text"
                              name="cardiac_stent_text"
                              onChange={this.onChange}
                            />
                          </span>
                        </React.Fragment>
                      </p>
                    </div>
                  </div>

                  <div className="yes_nonew_sec">
                    <div className="yes_no_check">
                      <input
                        type="radio"
                        value="yes"
                        name="valvularHeart"
                        checked={valvularHeart === "yes"}
                        onChange={this.onChange}
                      />
                      <input
                        type="radio"
                        value="no"
                        name="valvularHeart"
                        checked={valvularHeart === "no"}
                        onChange={this.onChange}
                        style={{ marginLeft: "20px" }}
                      />
                    </div>
                    <div className="yes_no_text">
                      <p>Do you have h/o aortic stenosis ?</p>
                    </div>
                  </div>

                  <div className="yes_nonew_sec">
                    <div className="yes_no_check">
                      <input
                        type="radio"
                        value="yes"
                        name="pacemaker"
                        checked={pacemaker === "yes"}
                        onChange={this.onChange}
                      />
                      <input
                        type="radio"
                        value="no"
                        name="pacemaker"
                        checked={pacemaker === "no"}
                        onChange={this.onChange}
                        style={{ marginLeft: "20px" }}
                      />
                    </div>
                    <div className="yes_no_text">
                      <p>Do you have a pacemaker / defibrillator / LVAD ?</p>
                    </div>
                  </div>

                  <div className="yes_nonew_sec">
                    <div className="yes_no_check">
                      <input
                        type="radio"
                        value="yes"
                        name="bloodthinners"
                        checked={bloodthinners === "yes"}
                        onChange={this.onChange}
                      />
                      <input
                        type="radio"
                        value="no"
                        name="bloodthinners"
                        checked={bloodthinners === "no"}
                        onChange={this.onChange}
                        style={{ marginLeft: "20px" }}
                      />
                    </div>
                    <div className="yes_no_text">
                      <p>
                        Are you taking any blood thinners, other than baby
                        aspirin?
                      </p>
                    </div>
                  </div>
                  <div className="yes_nonew_sec">
                    <div className="yes_no_check">
                      <input
                        type="radio"
                        value="yes"
                        name="breathingproblems"
                        checked={breathingproblems === "yes"}
                        onChange={this.onChange}
                      />
                      <input
                        type="radio"
                        value="no"
                        name="breathingproblems"
                        checked={breathingproblems === "no"}
                        onChange={this.onChange}
                        style={{ marginLeft: "20px" }}
                      />
                    </div>
                    <div className="yes_no_text">
                      <p>
                        Do you have any breathing problems/lung disease? (COPD,
                        Emphysema)
                      </p>
                    </div>
                  </div>
                  <div className="yes_nonew_sec">
                    <div className="yes_no_check">
                      <input
                        type="radio"
                        value="yes"
                        name="oxygen"
                        checked={oxygen === "yes"}
                        onChange={this.onChange}
                      />
                      <input
                        type="radio"
                        value="no"
                        name="oxygen"
                        checked={oxygen === "no"}
                        onChange={this.onChange}
                        style={{ marginLeft: "20px" }}
                      />
                    </div>
                    <div className="yes_no_text">
                      <p>Are you on continuous or supplemental oxygen?</p>
                    </div>
                  </div>
                  <div className="yes_nonew_sec">
                    <div className="yes_no_check">
                      <input
                        type="radio"
                        value="yes"
                        name="kidneydisease"
                        checked={kidneydisease === "yes"}
                        onChange={this.onChange}
                      />
                      <input
                        type="radio"
                        value="no"
                        name="kidneydisease"
                        checked={kidneydisease === "no"}
                        onChange={this.onChange}
                        style={{ marginLeft: "20px" }}
                      />
                    </div>
                    <div className="yes_no_text">
                      <p>
                        Are you on dialysis or diagnosed with kidney disease?
                      </p>
                    </div>
                  </div>
                  <div className="yes_nonew_sec">
                    <div className="yes_no_check">
                      <input
                        type="radio"
                        value="yes"
                        name="couldbepregnant"
                        checked={couldbepregnant === "yes"}
                        onChange={this.onChange}
                      />
                      <input
                        type="radio"
                        value="no"
                        name="couldbepregnant"
                        checked={couldbepregnant === "no"}
                        onChange={this.onChange}
                        style={{ marginLeft: "20px" }}
                      />
                    </div>
                    <div className="yes_no_text">
                      <p>Any chance you could be pregnant?</p>
                    </div>
                  </div>
                  <div className="yesno_stop">
                    <p>
                      <span>
                        <img src={StopImage} alt="Office Visit" width="30px" />
                      </span>
                      <span className="stop_cont_right">
                        If yes to any of the above six questions, schedule
                        patient for an office visit
                      </span>
                    </p>
                  </div>
                  <div className="next_yesno_sec">
                    <div className="yes_nonew_sec">
                      <div className="yes_no_check">
                        <input
                          type="radio"
                          value="yes"
                          name="bloodpressure"
                          checked={bloodpressure === "yes"}
                          onChange={this.onChange}
                        />
                        <input
                          type="radio"
                          value="no"
                          name="bloodpressure"
                          checked={bloodpressure === "no"}
                          onChange={this.onChange}
                          style={{ marginLeft: "20px" }}
                        />
                      </div>
                      <div className="yes_no_text">
                        <p>
                          Do have high blood pressure?{" "}
                          <React.Fragment>
                            If yes, is it controlled with medication?
                            <input
                              type="radio"
                              value="yes"
                              name="controlledwithmedication"
                              checked={controlledwithmedication === "yes"}
                              onChange={this.onChange}
                            />
                            <span>Yes</span>
                            <input
                              type="radio"
                              value="no"
                              name="controlledwithmedication"
                              checked={controlledwithmedication === "no"}
                              onChange={this.onChange}
                            />
                            <span>No</span>
                          </React.Fragment>
                        </p>
                      </div>
                    </div>
                    <div className="yes_nonew_sec">
                      <div className="yes_no_check">
                        <input
                          type="radio"
                          value="yes"
                          name="historyofseizures"
                          checked={historyofseizures === "yes"}
                          onChange={this.onChange}
                        />
                        <input
                          type="radio"
                          value="no"
                          name="historyofseizures"
                          checked={historyofseizures === "no"}
                          onChange={this.onChange}
                          style={{ marginLeft: "20px" }}
                        />
                      </div>
                      <div className="yes_no_text">
                        <p>Do you have a history of seizures?</p>
                      </div>
                    </div>
                    <div className="yes_nonew_sec">
                      <div className="yes_no_check">
                        <input
                          type="radio"
                          value="yes"
                          name="diabetic"
                          checked={diabetic === "yes"}
                          onChange={this.onChange}
                        />
                        <input
                          type="radio"
                          value="no"
                          name="diabetic"
                          checked={diabetic === "no"}
                          onChange={this.onChange}
                          style={{ marginLeft: "20px" }}
                        />
                      </div>
                      <div className="yes_no_text">
                        <p>
                          Are you diabetic?{" "}
                          <React.Fragment>
                            If yes,
                            <input
                              type="radio"
                              value="Type I"
                              name="diabeticyes"
                              checked={diabeticyes === "Type I"}
                              onChange={this.onChange}
                            />
                            <span>Type I</span>{" "}
                            <input
                              type="radio"
                              value="Type II"
                              name="diabeticyes"
                              checked={diabeticyes === "Type II"}
                              onChange={this.onChange}
                            />
                            <span>Type II</span>
                          </React.Fragment>
                          <React.Fragment>
                            <input
                              type="radio"
                              value="Other"
                              name="diabeticyes"
                              checked={diabeticyes === "Other"}
                              onChange={this.onChange}
                            />
                            Other:{" "}
                            <span className="d11">
                              <input
                                type="text"
                                name="diabeticOther_text"
                                onChange={this.onChange}
                              />
                            </span>
                          </React.Fragment>
                        </p>
                      </div>
                    </div>
                    <div className="yes_nonew_sec">
                      <div className="yes_no_check">
                        <input
                          type="radio"
                          value="yes"
                          name="anxietymedication"
                          checked={anxietymedication === "yes"}
                          onChange={this.onChange}
                        />
                        <input
                          type="radio"
                          value="no"
                          name="anxietymedication"
                          checked={anxietymedication === "no"}
                          onChange={this.onChange}
                          style={{ marginLeft: "20px" }}
                        />
                      </div>
                      <div className="yes_no_text">
                        <p>
                          Do you take prescription narcotics, anti-depressants,
                          sleep aids, anxiety medication?
                        </p>
                      </div>
                    </div>

                    <div className="yes_nonew_sec">
                      <div className="yes_no_check">
                        <input
                          type="radio"
                          value="yes"
                          name="circulatorydisorders"
                          checked={circulatorydisorders === "yes"}
                          onChange={this.onChange}
                        />
                        <input
                          type="radio"
                          value="no"
                          name="circulatorydisorders"
                          checked={circulatorydisorders === "no"}
                          onChange={this.onChange}
                          style={{ marginLeft: "20px" }}
                        />
                      </div>
                      <div className="yes_no_text">
                        <p>
                          Do you have any bleeding or circulatory disorders?{" "}
                          <React.Fragment>
                            Stroke, Blood Clots, Other:{" "}
                            <span className="s11">
                              <input
                                type="text"
                                name="circulatoryothername"
                                onChange={this.onChange}
                              />
                            </span>
                          </React.Fragment>
                        </p>
                      </div>
                    </div>
                   
                    <div className="yes_nonew_sec">
                      <div className="yes_no_check">
                        <input
                          type="radio"
                          value="yes"
                          name="problemwithanesthesia"
                          checked={problemwithanesthesia === "yes"}
                          onChange={this.onChange}
                        />
                        <input
                          type="radio"
                          value="no"
                          name="problemwithanesthesia"
                          checked={problemwithanesthesia === "no"}
                          onChange={this.onChange}
                          style={{ marginLeft: "20px" }}
                        />
                      </div>
                      <div className="yes_no_text">
                        <p>
                          Have you had any problem with anesthesia?{" "}
                          {/* {problemwithanesthesia === "yes" ? ( */}
                          <React.Fragment>
                            If yes, details :{" "}
                            <input
                              type="text"
                              name="problemwithanesthesiayes"
                              onChange={this.onChange}
                            />
                          </React.Fragment>
                          {/* ) : (
                            <React.Fragment></React.Fragment>
                          )} */}
                        </p>
                      </div>
                    </div>
                    <div className="yes_nonew_sec">
                      <div className="yes_no_check">
                        <input
                          type="radio"
                          value="yes"
                          name="transplantother"
                          checked={transplantother === "yes"}
                          onChange={this.onChange}
                        />
                        <input
                          type="radio"
                          value="no"
                          name="transplantother"
                          checked={transplantother === "no"}
                          onChange={this.onChange}
                          style={{ marginLeft: "20px" }}
                        />
                      </div>
                      <div className="yes_no_text">
                        <p>
                          Have you had an organ transplant other than cornea?{" "}
                          {/* {transplantother === "yes" ? ( */}
                          <React.Fragment>
                            If yes, what type:{" "}
                            <input
                              type="text"
                              name="transplantotheryes"
                              onChange={this.onChange}
                            />
                          </React.Fragment>
                          {/* ) : (
                            <React.Fragment></React.Fragment>
                          )} */}
                        </p>
                      </div>
                    </div>
                    <div className="yes_nonew_sec">
                      <div className="yes_no_check">
                        <input
                          type="radio"
                          value="yes"
                          name="bowelMovement"
                          checked={bowelMovement === "yes"}
                          onChange={this.onChange}
                          disabled
                        />
                        <input
                          type="radio"
                          value="no"
                          name="bowelMovement"
                          checked={bowelMovement === "no"}
                          onChange={this.onChange}
                          style={{ marginLeft: "20px" }}
                          disabled
                        />
                      </div>
                      <div className="yes_no_text flex">
                        <p>How often do you have a bowel movement? </p>
                        <div>
                          {bowelMovement === "yes" ? (
                            <React.Fragment>
                              <input
                                type="radio"
                                value="daily"
                                name="bowelMovement_options"
                                checked={bowelMovement_options === "daily"}
                                onChange={this.onChange}
                              />
                              Daily
                              <input
                                type="radio"
                                value="2-3 x's days"
                                name="bowelMovement_options"
                                checked={
                                  bowelMovement_options === "2-3 x's days"
                                }
                                onChange={this.onChange}
                              />
                              2-3 x's days
                              <input
                                type="radio"
                                value="every other day"
                                name="bowelMovement_options"
                                checked={
                                  bowelMovement_options === "every other day"
                                }
                                onChange={this.onChange}
                              />
                              Every other day
                              <input
                                type="radio"
                                value="Other"
                                name="bowelMovement_options"
                                onChange={this.onChange}
                              />
                              Other
                              {bowelMovement_options === "Other" ? (
                                <React.Fragment>
                                  <input
                                    type="text"
                                    value={bowelMovement_other_text}
                                    name="bowelMovement_other_text"
                                    onChange={this.onChange}
                                    style={{ width: "120px" }}
                                  />
                                </React.Fragment>
                              ) : (
                                <React.Fragment></React.Fragment>
                              )}
                            </React.Fragment>
                          ) : (
                            <React.Fragment></React.Fragment>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ==================== yes no  new html end ======================= */}
              <div className="submit_btn">
                <input
                  className="btnbtim"
                  type="button"
                  name="waq_submit"
                  value="Submit"
                  style={{
                    cursor: "pointer",
                    background: "#e6e6e6",
                    color: "#333333",
                    borderRadius: "4px",
                    padding: "1em",
                    marginBottom: "1em",
                  }}
                  onClick={this.onSubmit}
                />
              </div>
            </form>
            <div className="footer_details">
              <p className="address">
                981 State Highway 121 Suite 1140, Allen, TX 75013
              </p>
              <span className="block px-4">
                Office <span className="color_b border-r">469-697-5100</span>
              </span>
              <span className="block color_b px-4 border-r">
                Fax 469-697-5105
              </span>
              <span className="block px-4">
                <a href="www.yaminimaddalamd.com">www.yaminimaddalamd.com</a>
              </span>
            </div>
          </div>
        </div>

        {/* overlay loader */}
        {this.state.loading ? (
          <div className="loader-container">
            <div className="loader-content">
              <div className="loader"></div>
              <span className="loader-text">Submitting...</span>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

export default withRouter(Form1);
